const gqlConfig = {
  aws_appsync_region: 'eu-west-1', // Stack region
  aws_appsync_graphqlEndpoint: process.env.GRAPHQL_ENDPOINT, // AWS AppSync endpoint
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS', // Primary AWS AppSync authentication type
};

export default gqlConfig;
